import React from 'react';
import { useField, connect } from 'formik';

import OrderableList from '../OrderableList';


const FormikOrderableList = ({
  options: initialOptions,
  helperText,
  ...props
}: any) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  const [selectedOptionIds, setSelectedOptionIds] = React.useState(field.value || []);
  const ordered = initialOptions.sort((a: any, b: any) => {
    const ai = selectedOptionIds.indexOf(a.id) === -1 ? Infinity : selectedOptionIds.indexOf(a.id);
    const bi = selectedOptionIds.indexOf(b.id) === -1 ? Infinity : selectedOptionIds.indexOf(b.id);
    return ai - bi;
  });
  const [options, setOptions] = React.useState(ordered);

  return (
    <OrderableList
      {...field}
      {...props}
      selectedOptionIds={selectedOptionIds}
      setOptions={setOptions}
      options={options}
      onChange={(value: any) => {
        setSelectedOptionIds(value);
        props.formik.setFieldValue(props.name, value);
      }}
      helperText={helperText}
    />
  );
};

export default connect(FormikOrderableList);
